import { render, staticRenderFns } from "./ItensLotesPublico.vue?vue&type=template&id=7279ae5a&scoped=true"
import script from "./ItensLotesPublico.vue?vue&type=script&lang=js"
export * from "./ItensLotesPublico.vue?vue&type=script&lang=js"
import style0 from "./ItensLotesPublico.vue?vue&type=style&index=0&id=7279ae5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7279ae5a",
  null
  
)

export default component.exports